/**
 * 行情基础显示组件
 */
import React from "react"
import isNumber from "lodash/isNumber"
import {
  dateAllTransform,
  dateTransform,
  FormatArr,
  formatBigNumber,
  formatCompareColor,
  formatDate,
  formatHKBigNumber,
  formatHKTimeTradeColor,
  formatNumToFixed,
  formatPoint,
  formatSingleColor,
  formatStockColor,
  FormatStringDate,
  formatTipsCompareColor,
  formatTipsSingleColor,
  formatToSub,
  formatUniqueNumToFixed,
  formatUnit,
  formatUnitPk,
  formatUnitSpe,
  getFxfs,
  getProfit,
  getSpecialFxfs,
  getTradeStatus,
  getXppz,
  returnTransactionMode,
} from "../utils"
import { formatDirection, formatNewDirection } from "../icon"
import { BondType, getBondDetailType } from "../pagetype"

export enum quote_item_name {
  "名称",
  "股票代码",
  "最新价",
  "首页沪深京专用最新价",
  "最后价格",
  "涨跌幅",
  "涨跌额",
  "名称_指数",
  "最新价_指数",
  "涨跌幅_指数",
  "涨跌额_指数",
  "成交额_指数",
  "今开",
  "最高",
  "最低",
  "换手",
  "总手",
  "成交量",
  "成交笔数",
  "成交额",
  "总市值",
  "市值",
  "流通市值",
  "市盈率",
  "市净率",
  "长名称",
  "交易状态2",
  "日K时间",
  "板块代码",
  "板块名称",
  "均价",
  "昨收",
  "52周最高价",
  "52周最低价",
  "外盘",
  "内盘",
  "每股收益TTM",
  "市盈率TTM",
  "每股净资产",
  "市销率",
  "市销率_A",
  "净资产收益率",
  "总股本",
  "是否同股同权",
  "交易币种",
  "涨停价",
  "跌停价",
  "委比",
  "振幅",
  "今年涨幅",
  "收益",
  "每股收益",
  "收益序号",
  "市盈率(动)",
  "市盈率(TTM)",
  "市盈率(静)",
  "流通股本",
  "总注册股本",
  "发行股本",
  "已发行股本",
  "表决权差异",
  "协议控制架构",
  "是否盈利",
  "是否注册制",
  "盘后额",
  "盘后量",
  "量比",
  "量比_债券",
  "PE",
  "主力流入",
  "主力流出",
  "主力净流向",
  "超大单流入",
  "超大单流出",
  "大单流入",
  "大单流出",
  "中单流入",
  "中单流出",
  "小单流入",
  "小单流出",
  "净超大流入",
  "净大单流入",
  "净中单流入",
  "净小单流入",
  "净超大流出",
  "净大单流出",
  "净中单流出",
  "净小单流出",
  "流入",
  "流出",
  "盘后固定价格",
  "A股报价",
  "H股报价",
  "(A/H)比价",
  "(H/A)比价",
  "涨家数",
  "平家数",
  "跌家数",
  "转股价值",
  "转股溢价率",
  "正股名称",
  "正股最新价",
  "正股涨跌幅",
  "正股代码",
  "正股现价",
  "转债名称",
  "转债最新价",
  "转债涨跌幅",
  "转债代码",
  "可转债转股溢价率",
  "转股价格",
  "纯债价值",
  "纯债溢价率",
  "到期赎回价",
  "加权平均",
  "加权涨跌",
  "昨加权",
  "今加权",
  "加权涨跌BP",
  "资金可用日",
  "涨跌BP",
  "资金可取日",
  "万元收益",
  "占款天数",
  "借用天数",
  "最新YTM",
  "最近成交方式",
  "匹配成交价",
  "匹配成交量",
  "匹配成交涨幅",
  "匹配成交额",
  "全价",
  "应付利息",
  "面值",
  "发行规模",
  "上市日期",
  "票面利率",
  "到期日",
  "剩余年限",
  "付息日",
  "距付息日天数",
  "付息方式",
  "折合标准券",
  "息票品种",
  "债券类型",
  "港股本",
  "港值",
  "日增",
  "持仓",
  "结算",
  "昨结",
  "A/B股报价",
  "A/B股涨跌幅",
  "A/B股市场号",
  "A/B股代码",
  "(A/B)比价",
  "(B/A)比价",
  "成交量单位",
  "成交量单位_港股",
  "点差",
  "10日涨跌幅",
  "20日涨跌幅",
  "60日涨跌幅",
  "今年来涨跌幅",
  "卖1价",
  "买1价",
  "卖1量",
  "买1量",
  "计息天数",
  "千元收益",
  "仓差",
  "GDR报价",
  "(A/GDR)比价",
  "(GDR/A)比价",
  "港股双柜台最新价",
  "港股双柜台涨跌幅",
  "价差",
  "国债所属国家",
  "关键期限价差",
  "个券价差",
  "国债所属国家代码",
  "国债所属国家名称",
  "国债关键期限",
  "国债更新时间",
  "国债剩余年限",
  "国债到期日期",
  "国债涨跌BP",
  "国债票面利率",
  "国债最新YTM",
  "国债最优买YTM",
  "国债最优卖YTM",
}

export enum quote_item_trade_info {
  "卖1价",
  "卖1量",
  "买1价",
  "买1量",
  "卖2价",
  "卖2量",
  "买2价",
  "买2量",
  "卖3价",
  "卖3量",
  "买3价",
  "买3量",
  "卖4价",
  "卖4量",
  "买4价",
  "买4量",
  "卖5价",
  "卖5量",
  "买5价",
  "买5量",
  "卖6价",
  "卖6量",
  "买6价",
  "买6量",
  "卖7价",
  "卖7量",
  "买7价",
  "买7量",
  "卖8价",
  "卖8量",
  "买8价",
  "买8量",
  "卖9价",
  "卖9量",
  "买9价",
  "买9量",
  "分时",
}

// 分时右侧交易信息
export enum quote_item_fs_trade_info {
  "时间",
  "成交价",
  "成交量",
  "成交量_指数",
  "国债YTM",
  "单数",
}

export enum quote_item_bk_info {
  "模块名称",
  "板块涨幅",
  "领涨股",
  "个股涨幅",
}

// 相关品种
export enum quote_item_type_info {
  "名称",
  "股票代码",
  "最新价",
  "涨跌幅",
  "涨跌额",
}

// 成分股
export enum quote_item_cfg_info {
  "名称",
  "股票代码",
  "最新价",
  "涨跌幅",
  "涨跌幅_板块",
  "涨跌额",
}

export let single_quote = {
  [quote_item_name.名称]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f58,
      text: data == undefined ? "-" : data.f58,
      element: data == undefined ? <>-</> : <span>{data.f58}</span>,
    }
  },
  [quote_item_name.股票代码]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f57,
      text: data == undefined ? "-" : data.f57,
      element: data == undefined ? <>-</> : <span>{data.f57}</span>,
    }
  },
  [quote_item_name.最新价]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f43,
      text: data == undefined ? "-" : zoomData(data.f43, data.f59),
      element: data == undefined ? <span>-</span> : <span className={quoteColor(data.f169)}>{zoomData(data.f43, data.f59)}</span>,
      last_element: data == undefined ? <span>-</span> : <span className="black private-new-price">{zoomData(data.f43, data.f59)}</span>,
      new_element: data == undefined ? <p>-</p> : <p className={formatCompareColor(data.f43, data.f60)}>{formatNumToFixed(data.f43, data.f59)}</p>,
      bond_element: data == undefined ? <p>-</p> : <p className={formatCompareColor(data.f43, data.f60)}>{formatNumToFixed(data.f43, data.f59)}</p>,
      option_element: data == undefined ? <span>-</span> : <span className={formatCompareColor(data.f43, data.f130)}>{zoomData(data.f43, data.f59)}</span>,
      tips_element: data == undefined ? <>-</> : <p className={formatTipsCompareColor(data.f43, data.f60)}>{zoomData(data.f43, data.f59)}</p>,
      tips_pk_element: data == undefined ? <>-</> : <span className={formatTipsCompareColor(data.f43, data.f60)}>{zoomData(data.f43, data.f59)}</span>,
      pk_element: data == undefined ? <>-</> : <span className={formatCompareColor(data.f43, data.f60)}>{zoomData(data.f43, data.f59)}</span>,
    }
  },
  [quote_item_name.最后价格]: function (data: any) {
    if (data) {
      if (data.f301 != 0 && data.f301 != "-") {
        return single_quote[quote_item_name.首页沪深京专用最新价](data).element
      } else if (data.f43 != 0 && data.f43 != "-") {
        return single_quote[quote_item_name.最新价](data).last_element
      } else {
        return single_quote[quote_item_name.昨收](data).last_element
      }
    } else {
      return <>-</>
    }
  },
  [quote_item_name.首页沪深京专用最新价]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f301,
      text: data == undefined ? "-" : zoomData(data.f301, data.f59),
      element: data == undefined ? <>-</> : <span className="black private-new-price">{zoomData(data.f301, data.f59)}</span>,
    }
  },
  [quote_item_name.涨跌幅]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f170,
      text: data == undefined ? "-" : zoomData(data.f170, data.f152, true),
      element: data == undefined ? <>-</> : <span className={quoteColor(data.f169)}>{zoomData(data.f170, data.f152, true)}</span>,
      scale_element: data == undefined ? <>-</> : <span className={`${quoteColor(data.f169)} ${String(data.f170).length > 6 ? "scale-first-level" : ""}`}>{zoomData(data.f170, data.f152, true)}</span>,
      hk_element: data == undefined ? <>-</> : <span className={`${quoteColor(data.f169)} ${String(data.f170).length >= 5 ? "hk-scale-first-level" : ""}`}>{zoomData(data.f170, data.f152, true)}</span>,
      new_element: data == undefined ? <>-</> : <span className={`${formatCompareColor(data.f43, data.f60)}`}>{formatNumToFixed(data.f170, data.f152, "", "%")}</span>,
      bond_element: data == undefined ? <>-</> : <span className={`${formatCompareColor(data.f43, data.f60)}`}>{formatNumToFixed(data.f170, data.f152, "", "%")}</span>,
      tips_element: data == undefined ? <>-</> : <span className={`${formatTipsCompareColor(data.f43, data.f60)}`}>{formatNumToFixed(data.f170, data.f152, "", "%")}</span>,
      option_element: data == undefined ? <>-</> : <span className={`${formatCompareColor(data.f43, data.f130)}`}>{zoomData(data.f170, data.f152, true)}</span>,
      // 质押回购
      zy_bond_element: data == undefined ? <>-</> : <span className={`${formatCompareColor(data.f43, data.f60)}`}>{formatUniqueNumToFixed(data.f169 * 100, data.f59, data.f152, " BP")}</span>,
    }
  },
  [quote_item_name.涨跌额]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f169,
      text: data == undefined ? "-" : zoomData(data.f169, data.f59),
      element: data == undefined ? <>-</> : <span className={quoteColor(data.f169)}>{zoomData(data.f169, data.f59)}</span>,
      scale_element: data == undefined ? <>-</> : <span className={`${quoteColor(data.f169)} ${String(data.f169).length > 5 ? "scale-first-level" : ""}`}>{zoomData(data.f169, data.f59)}</span>,
      hk_element: data == undefined ? <>-</> : <span className={`${quoteColor(data.f169)} ${String(data.f169).length > 5 ? "hk-scale-first-level" : ""}`}>{zoomData(data.f169, data.f59)}</span>,
      new_element: data == undefined ? <>-</> : <span className={`${formatCompareColor(data.f43, data.f60)}`}>{formatNumToFixed(data.f169, data.f59)}</span>,
      bond_element: data == undefined ? <>-</> : <span className={`${formatCompareColor(data.f43, data.f60)}`}>{formatNumToFixed(data.f169, data.f59)}</span>,
      tips_element: data == undefined ? <>-</> : <span className={`${formatTipsCompareColor(data.f43, data.f60)}`}>{formatNumToFixed(data.f169, data.f59)}</span>,
      option_element: data == undefined ? <>-</> : <span className={`${formatCompareColor(data.f43, data.f130)}`}>{zoomData(data.f169, data.f59)}</span>,
    }
  },
  [quote_item_name.名称_指数]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f58,
      text: data == undefined ? "-" : data.f58,
      element: data == undefined ? <>-</> : <span className="index-title">{data.f58}</span>,
    }
  },
  [quote_item_name.最新价_指数]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f43,
      text: data == undefined ? "-" : zoomData(data.f43, data.f59),
      element: data == undefined ? <>-</> : <span className={formatCompareColor(data.f43, data.f60)}>{zoomData(data.f43, data.f59)}</span>,
    }
  },
  [quote_item_name.涨跌幅_指数]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f170,
      text: data == undefined ? "-" : zoomData(data.f170, data.f152, true),
      element: data == undefined ? <>-</> : <span className={formatCompareColor(data.f43, data.f60)}>{zoomData(data.f170, data.f152, true)}</span>,
    }
  },
  [quote_item_name.涨跌额_指数]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f169,
      text: data == undefined ? "-" : zoomData(data.f169, data.f59),
      element: data == undefined ? <>-</> : <span className={formatCompareColor(data.f43, data.f60)}>{zoomData(data.f169, data.f59)}</span>,
    }
  },
  [quote_item_name.成交额_指数]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f48,
      text: data == undefined ? "-" : formatBigNumber(data.f48, 2),
      element: data == undefined ? <>-</> : <span>{formatBigNumber(data.f48, 2)}</span>,
    }
  },
  [quote_item_name.今开]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f46,
      text: data == undefined ? "-" : zoomData(data.f46, data.f59),
      element: data == undefined ? <>-</> : <span className={formatStockColor(data.f46, data.f60)}>{zoomData(data.f46, data.f59)}</span>,
      tips_element: data == undefined ? <>-</> : <span className={formatTipsCompareColor(data.f46, data.f60)}>{zoomData(data.f46, data.f59)}</span>,
      // 期权
      option_element: data == undefined ? <>-</> : <span className={formatStockColor(data.f46, data.f130)}>{zoomData(data.f46, data.f59)}</span>,
    }
  },
  [quote_item_name.最高]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f44,
      text: data == undefined ? "-" : zoomData(data.f44, data.f59),
      element: data == undefined ? <>-</> : <span className={formatStockColor(data.f44, data.f60)}>{zoomData(data.f44, data.f59)}</span>,
      tips_element: data == undefined ? <>-</> : <span className={formatTipsCompareColor(data.f44, data.f60)}>{zoomData(data.f44, data.f59)}</span>,
      option_element: data == undefined ? <>-</> : <span className={formatStockColor(data.f44, data.f130)}>{zoomData(data.f44, data.f59)}</span>,
    }
  },
  [quote_item_name.最低]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f45,
      text: data == undefined ? "-" : zoomData(data.f45, data.f59),
      element: data == undefined ? <>-</> : <span className={formatStockColor(data.f45, data.f60)}>{zoomData(data.f45, data.f59)}</span>,
      tips_element: data == undefined ? <>-</> : <span className={formatTipsCompareColor(data.f45, data.f60)}>{zoomData(data.f45, data.f59)}</span>,
      option_element: data == undefined ? <>-</> : <span className={formatStockColor(data.f45, data.f130)}>{zoomData(data.f45, data.f59)}</span>,
    }
  },
  [quote_item_name.换手]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f168,
      text: data == undefined ? "-" : formatUnit(formatNumToFixed(data.f168, data.f152), "%"),
      element: data == undefined ? <>-</> : <span>{formatUnit(formatNumToFixed(data.f168, data.f152), "%")}</span>,
    }
  },
  [quote_item_name.总手]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f47,
      text: data == undefined ? "-" : formatBigNumber(data.f47, 2),
      element: data == undefined ? <>-</> : <span>{formatBigNumber(data.f47, 2)}</span>,
      new_element: data == undefined ? <>-</> : <span className={getLongDataScaleClass(395, "")}>{formatBigNumber(data.f47, 2, window.innerWidth < 360 ? "" : "")}</span>,
      pk_element: data == undefined ? <>-</> : <span>{formatBigNumber(data.f47, 2, "")}</span>,
      bk_element: data == undefined ? <>-</> : <span>{formatBigNumber(data.f47, 2)}</span>,
    }
  },
  [quote_item_name.持仓]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f133,
      text: data == undefined ? "-" : formatBigNumber(data.f133, 2),
      element: data == undefined ? <>-</> : <span>{formatBigNumber(data.f133, 2)}</span>,
    }
  },
  [quote_item_name.日增]: function (data: any) {
    // console.info('日增', data)
    
    return {
      source: data == undefined ? "-" : data.f133,
      text: data == undefined ? "-" : formatToSub(data.f133, data.f132),
      element: data == undefined ? <>-</> : <span className={formatSingleColor(data.f133 - data.f132)}>{formatToSub(data.f133, data.f132)}</span>,
    }
  },
  [quote_item_name.结算]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f131,
      text: data == undefined ? "-" : formatNumToFixed(data.f131, data.f59),
      element: data == undefined ? <>-</> : <span>{formatNumToFixed(data.f131, data.f59)}</span>,
      qh_element: data == undefined ? <>-</> : <span className={formatStockColor(data.f131, data.f130)}>{formatNumToFixed(data.f131, data.f59)}</span>,
    }
  },
  [quote_item_name.昨结]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f130,
      text: data == undefined ? "-" : formatNumToFixed(data.f130, data.f59),
      element: data == undefined ? <>-</> : <span>{formatNumToFixed(data.f130, data.f59)}</span>,
    }
  },
  [quote_item_name.成交笔数]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f296,
      text: data == undefined ? "-" : formatBigNumber(data.f296, 2, "笔"),
      element: data == undefined ? <>-</> : <span>{formatBigNumber(data.f296, data.f296 == 0 ? 0 : 2, "笔")}</span>,
    }
  },
  [quote_item_name.成交量]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f47,
      text: data == undefined ? "-" : formatBigNumber(data.f47, data.f59),
      element: data == undefined ? <>-</> : <span>{formatBigNumber(data.f47, data.f59)}</span>,
      new_element: data == undefined ? <>-</> : <span>{data.f47}</span>,
      bond_element: data == undefined ? <>-</> : <p>{formatBigNumber(data.f47, data.f59)}</p>,
      new_bond_element: data == undefined ? <>-</> : <span>{formatBigNumber(data.f47, 2)}</span>,
    }
  },
  [quote_item_name.成交额]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f48,
      text: data == undefined ? "-" : formatBigNumber(data.f48, data.f59),
      element: data == undefined ? <>-</> : <span className={getScaleClass()}>{formatBigNumber(data.f48, 2)}</span>,
      bond_element: data == undefined ? <>-</> : <span>{formatBigNumber(data.f48, 2)}</span>,
      new_bond_element: data == undefined ? <>-</> : <span>{formatBigNumber(data.f48, 0)}</span>,
      new_element: data == undefined ? <>-</> : <p>{formatBigNumber(data.f48, 0)}</p>,
    }
  },
  [quote_item_name.总市值]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f116,
      text: data == undefined ? "-" : formatBigNumber(data.f116, data.f59),
      element: data == undefined ? <>-</> : <span>{formatBigNumber(data.f116, data.f59)}</span>,
      hk_element: data == undefined ? <>-</> : <span>{formatBigNumber(data.f116, 2)}</span>,
    }
  },
  [quote_item_name.市值]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f117,
      text: data == undefined ? "-" : formatBigNumber(data.f117, data.f59),
      element: data == undefined ? <>-</> : <span>{formatBigNumber(data.f117, data.f59)}</span>,
      hk_element: data == undefined ? <>-</> : <span>{formatBigNumber(data.f117, 2)}</span>,
    }
  },
  [quote_item_name.流通市值]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f117,
      text: data == undefined ? "-" : formatBigNumber(data.f117, data.f59),
      element: data == undefined ? <>-</> : <span>{formatBigNumber(data.f117, data.f59)}</span>,
      hk_element: data == undefined ? <>-</> : <span>{formatBigNumber(data.f117, 2)}</span>,
    }
  },
  [quote_item_name.市盈率]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f164,
      text: data == undefined ? "-" : formatNumToFixed(data.f164, data.f152),
      element: data == undefined ? <>-</> : <span>{formatNumToFixed(data.f164, data.f152)}</span>,
    }
  },
  [quote_item_name.市净率]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f167,
      text: data == undefined ? "-" : formatNumToFixed(data.f167, data.f152),
      element: data == undefined ? <>-</> : <span>{formatNumToFixed(data.f167, data.f152)}</span>,
    }
  },
  [quote_item_name.长名称]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f734,
      text: data == undefined ? "-" : data.f734,
      element: data == undefined ? <>-</> : <span>{data.f734}</span>,
    }
  },
  [quote_item_name.交易状态2]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f292,
      text: data == undefined ? "-" : data.f292,
      element: data == undefined ? <>-</> : <span>{getTradeStatus(data.f292)}</span>,
    }
  },
  [quote_item_name.板块代码]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f198,
      text: data == undefined ? "-" : data.f198,
    }
  },
  [quote_item_name.板块名称]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f127,
      text: data == undefined ? "-" : data.f127,
      element: data == undefined ? <>-</> : <span>{data.f127}</span>,
    }
  },
  [quote_item_name.均价]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f71,
      text: data == undefined ? "-" : data.f71,
      element: data == undefined ? <>-</> : <span className={formatStockColor(data.f71, data.f60)}>{formatNumToFixed(data.f71, data.f59)}</span>,
      tips_element: data == undefined ? <>-</> : <span className={formatTipsCompareColor(data.f71, data.f60)}>{formatNumToFixed(data.f71, data.f59)}</span>,
      option_element: data == undefined ? <>-</> : <span className={formatStockColor(data.f71, data.f130)}>{zoomData(data.f71, data.f59)}</span>,
    }
  },
  [quote_item_name.昨收]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f60,
      text: data == undefined ? "-" : data.f60,
      element: data == undefined ? <>-</> : <span>{formatNumToFixed(data.f60, data.f59)}</span>,
      last_element: data == undefined ? <>-</> : <span className="black private-new-price">{formatNumToFixed(data.f60, data.f59)}</span>,
    }
  },
  [quote_item_name["52周最高价"]]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f174,
      text: data == undefined ? "-" : data.f174,
      element: data == undefined ? <>-</> : <span className={getLongDataScaleClass(380, "")}>{formatNumToFixed(data.f174, data.f59)}</span>,
      colored_element: data == undefined ? <>-</> : <span className={formatCompareColor(data.f174, data.f60)}>{formatNumToFixed(data.f174, data.f59)}</span>,
    }
  },
  [quote_item_name["52周最低价"]]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f175,
      text: data == undefined ? "-" : data.f175,
      element: data == undefined ? <>-</> : <span className={getLongDataScaleClass(380, "long-data-position")}>{formatNumToFixed(data.f175, data.f59)}</span>,
      colored_element: data == undefined ? <>-</> : <span className={formatCompareColor(data.f175, data.f60)}>{formatNumToFixed(data.f175, data.f59)}</span>,
    }
  },
  [quote_item_name.外盘]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f49,
      text: data == undefined ? "-" : data.f49,
      element: data == undefined ? <>-</> : <span className={data.f49 == "-" ? "" : "red"}>{formatBigNumber(data.f49, data.f59)}</span>,
    }
  },
  [quote_item_name.内盘]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f161,
      text: data == undefined ? "-" : data.f161,
      element: data == undefined ? <>-</> : <span className={data.f161 == "-" ? "" : "green"}>{formatBigNumber(data.f161, data.f59)}</span>,
    }
  },
  [quote_item_name.每股收益TTM]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f108,
      text: data == undefined ? "-" : data.f108,
      element: data == undefined ? <>-</> : <span>{formatPoint(data.f108, 3)}</span>,
      us_element: data == undefined ? <>-</> : <span className={setLongDataClass(380, "special-font")}>{formatUnit(data.f108, "calc", 2)}</span>,
    }
  },
  [quote_item_name.市盈率TTM]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f164,
      text: data == undefined ? "-" : data.f164,
      element: data == undefined ? <>-</> : <span>{formatNumToFixed(data.f164, data.f152)}</span>,
    }
  },
  [quote_item_name.每股净资产]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f92,
      text: data == undefined ? "-" : data.f92,
      element: data == undefined ? <>-</> : <span>{formatPoint(data.f92, 3)}</span>,
      us_element: data == undefined ? <>-</> : <span className={setLongDataClass(380, "special-font")}>{formatUnit(data.f92, "calc", 2)}</span>,
    }
  },
  [quote_item_name.市销率]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f176,
      text: data == undefined ? "-" : data.f176,
      element: data == undefined ? <>-</> : <span>{formatNumToFixed(data.f176, data.f152)}</span>,
    }
  },
  [quote_item_name.市销率_A]: function (data: any) {
    // 港股也用该字段
    return {
      source: data == undefined ? "-" : data.f165,
      text: data == undefined ? "-" : data.f165,
      element: data == undefined ? <>-</> : <span>{formatNumToFixed(data.f165, data.f152)}</span>,
    }
  },
  [quote_item_name.净资产收益率]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f173,
      text: data == undefined ? "-" : data.f173,
      element: data == undefined ? <>-</> : <span>{formatPoint(data.f173, 2, true)}</span>,
    }
  },
  [quote_item_name.总股本]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f84,
      text: data == undefined ? "-" : data.f84,
      element: data == undefined ? <>-</> : <span>{formatBigNumber(data.f84, 2)}</span>,
    }
  },
  [quote_item_name.是否同股同权]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f279,
      text: data == undefined ? "-" : data.f279,
      element: data == undefined ? <>-</> : <span>{data.f279 == 1 ? "是" : "否"}</span>,
    }
  },
  [quote_item_name.交易币种]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f600,
      text: data == undefined ? "-" : data.f600,
      element:
        data == undefined ? (
          <>-</>
        ) : (
          <span>
            {data.f172}({data.f600})
          </span>
        ),
    }
  },
  [quote_item_name.涨停价]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f51,
      text: data == undefined ? "-" : data.f51,
      element: data == undefined ? <>-</> : <span className={formatCompareColor(data.f51, data.f60)}>{formatNumToFixed(data.f51, data.f59)}</span>,
      tips_element: data == undefined ? <span>-</span> : <span className={formatTipsSingleColor(data.f169)}>{formatNumToFixed(data.f51, data.f59)}</span>,
      short_term_bond_element: data == undefined ? <span>-</span> : <span className={formatSingleColor(data.f169)}>{formatNumToFixed(data.f51, data.f59)}</span>,
    }
  },
  [quote_item_name.跌停价]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f52,
      text: data == undefined ? "-" : data.f52,
      element: data == undefined ? <>-</> : <span className={formatCompareColor(data.f52, data.f60)}>{formatNumToFixed(data.f52, data.f59)}</span>,
    }
  },
  [quote_item_name.委比]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f191,
      text: data == undefined ? "-" : data.f191,
      element: data == undefined ? <>-</> : <span>{formatUnit(formatNumToFixed(data.f191, data.f152), "%")}</span>,
    }
  },
  [quote_item_name.振幅]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f171,
      text: data == undefined ? "-" : data.f171,
      element: data == undefined ? <>-</> : <span>{formatUnit(formatNumToFixed(data.f171, data.f152), "%")}</span>,
    }
  },
  [quote_item_name.今年涨幅]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f122,
      text: data == undefined ? "-" : data.f122,
      element: data == undefined ? <>-</> : <span className={formatSingleColor(data.f122)}>{formatUnit(formatNumToFixed(data.f122, data.f152), "%")}</span>,
    }
  },
  [quote_item_name.每股收益]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f55,
      text: data == undefined ? "-" : data.f55,
      element: data == undefined ? <>-</> : <span>{formatUnit(data.f55, "calc", 3)}</span>,
    }
  },
  [quote_item_name.收益序号]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f62,
      text: data == undefined ? "-" : getProfit(data.f62),
    }
  },
  [quote_item_name["市盈率(动)"]]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f162,
      text: data == undefined ? "-" : data.f162,
      element: data == undefined ? <>-</> : <span>{formatNumToFixed(data.f162, data.f152)}</span>,
    }
  },
  [quote_item_name["市盈率(TTM)"]]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f164,
      text: data == undefined ? "-" : data.f164,
      element: data == undefined ? <>-</> : <span>{formatNumToFixed(data.f164, data.f152)}</span>,
    }
  },
  [quote_item_name["市盈率(静)"]]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f163,
      text: data == undefined ? "-" : data.f163,
      element: data == undefined ? <>-</> : <span>{formatNumToFixed(data.f163, data.f152)}</span>,
    }
  },
  [quote_item_name.流通股本]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f85,
      text: data == undefined ? "-" : data.f85,
      element: data == undefined ? <>-</> : <span>{formatUnit(data.f85, "calc", 2)}</span>,
    }
  },
  [quote_item_name.总注册股本]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f277,
      text: data == undefined ? "-" : data.f277,
      element: data == undefined ? <>-</> : <span>{formatUnit(data.f277, "calc", 2)}</span>,
    }
  },
  [quote_item_name.发行股本]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f278,
      text: data == undefined ? "-" : data.f278,
      element: data == undefined ? <>-</> : <span>{formatUnit(data.f278, "calc", 2)}</span>,
    }
  },
  [quote_item_name.表决权差异]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f293,
      text: data == undefined ? "-" : data.f293,
      element: data == undefined ? <>-</> : <span>{data.f293 == 0 ? "否" : data.f293 == 1 ? "是" : "-"}</span>,
    }
  },
  [quote_item_name.协议控制架构]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f295,
      text: data == undefined ? "-" : data.f295,
      element: data == undefined ? <>-</> : <span>{data.f295 == 0 ? "否" : data.f295 == 1 ? "是" : "-"}</span>,
    }
  },
  [quote_item_name.是否盈利]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f288,
      text: data == undefined ? "-" : data.f288,
      element: data == undefined ? <>-</> : <span>{data.f288 == 0 ? "是" : data.f288 == 1 ? "否" : "-"}</span>,
    }
  },
  [quote_item_name.是否注册制]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f294,
      text: data == undefined ? "-" : data.f294,
      element: data == undefined ? <>-</> : <span>{data.f294 == 0 ? "否" : data.f294 == 1 ? "是" : "-"}</span>,
    }
  },
  [quote_item_name.盘后量]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f260,
      text: data == undefined ? "-" : formatBigNumber(data.f260),
      element: data == undefined ? <>-</> : <span>{formatBigNumber(data.f260)}</span>,
    }
  },
  [quote_item_name.盘后额]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f261,
      text: data == undefined ? "-" : formatBigNumber(data.f261, 2),
      element: data == undefined ? <>-</> : <span>{formatBigNumber(data.f261, 2)}</span>,
    }
  },
  [quote_item_name.仓差]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f134,
      text: data == undefined ? "-" : data.f134,
      element: data == undefined ? <>-</> : <span className={formatSingleColor(data.f134)}>{data.f134}</span>,
    }
  },
  [quote_item_name.量比]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f50,
      text: data == undefined ? "-" : data.f50,
      element: data == undefined ? <>-</> : <span>{formatNumToFixed(data.f50, data.f152)}</span>,
    }
  },
  [quote_item_name.量比_债券]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f50,
      text: data == undefined ? "-" : data.f50,
      element: data == undefined ? <>-</> : <span>{formatNumToFixed(data.f50, data.f152)}</span>,
    }
  },
  [quote_item_name.PE]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f164,
      text: data == undefined ? "-" : data.f164,
      element: data == undefined ? <>-</> : <span>{formatUniqueNumToFixed(data.f164, 2, 3)}</span>,
    }
  },
  [quote_item_name.主力流入]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f135,
      text: data == undefined ? "-" : data.f135,
      element: data == undefined ? <>-</> : <span className="red">{formatUnitSpe(data.f135, 10000, "", true)}</span>,
    }
  },
  [quote_item_name.主力流出]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f136,
      text: data == undefined ? "-" : data.f136,
      element: data == undefined ? <>-</> : <span className="green">{formatUnitSpe(data.f136, 10000, "", true)}</span>,
    }
  },
  [quote_item_name.主力净流向]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f137,
      text: data == undefined ? "-" : data.f137,
      element: data == undefined ? <>-</> : <span className={formatCompareColor(data.f135, data.f136)}>{formatUnitSpe(data.f137, 10000, "", true)}</span>,
    }
  },
  [quote_item_name.超大单流入]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f138,
      text: data == undefined ? "-" : data.f138,
      element: data == undefined ? <>-</> : <span className="red">{data.f138 == "-" ? "-" : formatUnitPk(data.f138)}</span>,
    }
  },
  [quote_item_name.超大单流出]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f139,
      text: data == undefined ? "-" : data.f139,
      element: data == undefined ? <>-</> : <span className="green">{formatUnit(data.f139, "calc") == 0 ? 0 : formatUnitPk(data.f139)}</span>,
    }
  },
  [quote_item_name.大单流入]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f141,
      text: data == undefined ? "-" : data.f141,
      element: data == undefined ? <>-</> : <span className="red">{data.f141 == "-" ? "-" : formatUnitPk(data.f141)}</span>,
    }
  },
  [quote_item_name.大单流出]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f142,
      text: data == undefined ? "-" : data.f142,
      element: data == undefined ? <>-</> : <span className="green">{formatUnit(data.f142, "calc") == 0 ? 0 : formatUnitPk(data.f142)}</span>,
    }
  },
  [quote_item_name.中单流入]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f144,
      text: data == undefined ? "-" : data.f144,
      element: data == undefined ? <>-</> : <span className="red">{data.f144 == "-" ? "-" : formatUnitPk(data.f144)}</span>,
    }
  },
  [quote_item_name.中单流出]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f145,
      text: data == undefined ? "-" : data.f145,
      element: data == undefined ? <>-</> : <span className="green">{formatUnit(data.f145, "calc") == 0 ? 0 : formatUnitPk(data.f145)}</span>,
    }
  },
  [quote_item_name.小单流入]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f147,
      text: data == undefined ? "-" : data.f147,
      element: data == undefined ? <>-</> : <span className="red">{data.f147 == "-" ? "-" : formatUnitPk(data.f147)}</span>,
    }
  },
  [quote_item_name.小单流出]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f148,
      text: data == undefined ? "-" : data.f148,
      element: data == undefined ? <>-</> : <span className="green">{formatUnit(data.f148, "calc") == 0 ? 0 : formatUnitPk(data.f148)}</span>,
    }
  },
  [quote_item_name.净超大流入]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f140,
      text: data == undefined ? "-" : data.f140,
      element: data == undefined ? <>-</> : data.f140 > 0 ? <li style={{ backgroundColor: "#f22323", height: `${formatUnitSpe(data.f140, 10000, "", true) == "0" ? 0 : (data.f140 / data.AmtNetMax) * 85}%` }}></li> : <li className="down-color">{formatUnitSpe(data.f140, 10000, "", true)}</li>,
    }
  },
  [quote_item_name.净超大流出]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f140,
      text: data == undefined ? "-" : data.f140,
      element: data == undefined ? <>-</> : data.f140 > 0 ? <li className="up-color">{formatUnitSpe(data.f140, 10000, "", true)}</li> : <li style={{ backgroundColor: "#00a000", height: `${formatUnitSpe(data.f140, 10000, "", true) == "0" ? 0 : (-data.f140 / data.AmtNetMax) * 85}%` }}></li>,
    }
  },
  [quote_item_name.净大单流入]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f143,
      text: data == undefined ? "-" : data.f143,
      element: data == undefined ? <>-</> : data.f143 > 0 ? <li style={{ backgroundColor: "#f22323", height: `${formatUnitSpe(data.f143, 10000, "", true) == "0" ? 0 : (data.f143 / data.AmtNetMax) * 85}%` }}></li> : <li className="down-color">{formatUnitSpe(data.f143, 10000, "", true)}</li>,
    }
  },
  [quote_item_name.净大单流出]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f143,
      text: data == undefined ? "-" : data.f143,
      element: data == undefined ? <>-</> : data.f143 > 0 ? <li className="up-color">{formatUnitSpe(data.f143, 10000, "", true)}</li> : <li style={{ backgroundColor: "#00a000", height: `${formatUnitSpe(data.f143, 10000, "", true) == "0" ? 0 : (-data.f143 / data.AmtNetMax) * 85}%` }}></li>,
    }
  },
  [quote_item_name.净中单流入]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f146,
      text: data == undefined ? "-" : data.f146,
      element: data == undefined ? <>-</> : data.f146 > 0 ? <li style={{ backgroundColor: "#f22323", height: `${formatUnitSpe(data.f146, 10000, "", true) == "0" ? 0 : (data.f146 / data.AmtNetMax) * 85}%` }}></li> : <li className="down-color">{formatUnitSpe(data.f146, 10000, "", true)}</li>,
    }
  },
  [quote_item_name.净中单流出]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f146,
      text: data == undefined ? "-" : data.f146,
      element: data == undefined ? <>-</> : data.f146 > 0 ? <li className="up-color">{formatUnitSpe(data.f146, 10000, "", true)}</li> : <li style={{ backgroundColor: "#00a000", height: `${formatUnitSpe(data.f146, 10000, "", true) == "0" ? 0 : (-data.f146 / data.AmtNetMax) * 85}%` }}></li>,
    }
  },
  [quote_item_name.净小单流入]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f149,
      text: data == undefined ? "-" : data.f149,
      element: data == undefined ? <>-</> : data.f149 > 0 ? <li style={{ backgroundColor: "#f22323", height: `${formatUnitSpe(data.f149, 10000, "", true) == "0" ? 0 : (data.f149 / data.AmtNetMax) * 85}%` }}></li> : <li className="down-color">{formatUnitSpe(data.f149, 10000, "", true)}</li>,
    }
  },
  [quote_item_name.净小单流出]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f149,
      text: data == undefined ? "-" : data.f149,
      element: data == undefined ? <>-</> : data.f149 > 0 ? <li className="up-color">{formatUnitSpe(data.f149, 10000, "", true)}</li> : <li style={{ backgroundColor: "#00a000", height: `${formatUnitSpe(data.f149, 10000, "", true) == "0" ? 0 : (-data.f149 / data.AmtNetMax) * 85}%` }}></li>,
    }
  },
  [quote_item_name.流入]: function (item: any, value: any, index: number) {
    return {
      element:
        item == undefined ? (
          <>-</>
        ) : item.mainNetAmt > 0 ? (
          <li style={{ backgroundColor: "#f22323", height: `${formatUnitSpe(item.mainNetAmt, 10000, "", true) == "0" ? 0 : (item.mainNetAmt / value) * 85}%` }} key={index}></li>
        ) : (
          <li className={`down-color ${getSmallScreenDeviceClass()}`} key={index}>
            {formatUnitSpe(item.mainNetAmt, 10000, "", true)}
          </li>
        ),
    }
  },
  [quote_item_name.流出]: function (item: any, value: any, index: number) {
    return {
      element:
        item == undefined ? (
          <>-</>
        ) : item.mainNetAmt > 0 ? (
          <li className={`up-color ${getSmallScreenDeviceClass()}`} key={index}>
            {formatUnitSpe(item.mainNetAmt, 10000, "", true)}
          </li>
        ) : (
          <li style={{ backgroundColor: "#00a000", height: `${formatUnitSpe(item.mainNetAmt, 10000, "", true) == "0" ? 0 : (-item.mainNetAmt / value) * 85}%` }} key={index}></li>
        ),
    }
  },
  [quote_item_name.盘后固定价格]: function (data: any) {
    return {
      element: data == undefined ? <>-</> : <span className={data.f43 - data.f60 > 0 ? "red" : data.f43 - data.f60 < 0 ? "green" : ""}>{zoomData(data.f43, data.f59)}</span>,
    }
  },
  [quote_item_name.A股报价]: function (data: any) {
    let percent = data ? formatNumToFixed(data.f252, data.f152) : "-"
    let color = percent == "-" || percent == 0 ? "black" : percent > 0 ? "red" : "green"
    percent = percent > 0 ? `${percent}%` : percent < 0 ? `${percent}%` : "0.00%"
    return {
      element:
        data == undefined ? (
          <>-</>
        ) : (
          <span className={color}>
            {formatNumToFixed(data.f251, data.f255)}&nbsp;&nbsp;{percent}
          </span>
        ),
    }
  },
  [quote_item_name["(A/H)比价"]]: function (data: any) {
    const comparsion = data ? formatNumToFixed(data.f254, data.f152) : "-"
    return {
      element: data == undefined ? <>-</> : <span className={comparsion == "-" ? "black" : comparsion > 1 ? "red" : "green"}>{comparsion}</span>,
    }
  },
  [quote_item_name.H股报价]: function (data: any) {
    let percent = data ? formatNumToFixed(data.f252, data.f152) : "-"
    let color = percent == "-" || percent == 0 ? "black" : percent > 0 ? "red" : "green"
    percent = percent > 0 ? `${percent}%` : percent < 0 ? `${percent}%` : "0.00%"
    return {
      element:
        data == undefined ? (
          <>-</>
        ) : (
          <span className={color}>
            {formatNumToFixed(data.f251, data.f255)}&nbsp;&nbsp;{percent}
          </span>
        ),
    }
  },
  [quote_item_name["(H/A)比价"]]: function (data: any) {
    const comparsion = data && isNumber(data.f254) && data.f254 != 0 ? formatNumToFixed((1 / formatNumToFixed(data.f254, data.f152)) * Math.pow(10, data.f152), data.f152) : "-"
    return {
      element: data == undefined ? <>-</> : <span className={comparsion == "-" ? "black" : comparsion > 1 ? "red" : "green"}>{comparsion}</span>,
    }
  },
  [quote_item_name.涨家数]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f113,
      text: data == undefined ? "-" : data.f113,
      element: data == undefined ? <>-</> : <span className="red">{data.f113}</span>,
    }
  },
  [quote_item_name.平家数]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f115,
      text: data == undefined ? "-" : data.f115,
      element: data == undefined ? <>-</> : <span>{data.f115}</span>,
    }
  },
  [quote_item_name.跌家数]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f114,
      text: data == undefined ? "-" : data.f114,
      element: data == undefined ? <>-</> : <span className="green">{data.f114}</span>,
    }
  },
  [quote_item_name.转股价值]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f427,
      text: data == undefined ? "-" : data.f427,
      element: data == undefined ? <>-</> : <span>{formatUniqueNumToFixed(data.f427, data.f154, data.f152)}</span>,
      pk_element: data == undefined ? <>-</> : <span>{formatUniqueNumToFixed(data.f427, data.f154, data.f154)}</span>,
    }
  },
  [quote_item_name.转股溢价率]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f428,
      text: data == undefined ? "-" : data.f428,
      element: data == undefined ? <>-</> : <span className={formatStockColor(data.f428, 0)}> {formatNumToFixed(data.f428, data.f152, "", "%")}</span>,
    }
  },
  [quote_item_name.正股名称]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f264,
      text: data == undefined ? "-" : data.f264,
      element: data == undefined ? <>-</> : <span>{data.f264}</span>,
      colored_element: data == undefined ? <>-</> : <span className={formatCompareColor(data.f264, data.f266)}>{data.f264}</span>,
    }
  },
  [quote_item_name.正股最新价]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f267,
      text: data == undefined ? "-" : data.f267,
      element: data == undefined ? <>-</> : <span className={formatCompareColor(data.f267, data.f266)}>{formatNumToFixed(data.f267, data.f265)}</span>,
    }
  },
  [quote_item_name.正股涨跌幅]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f268,
      text: data == undefined ? "-" : data.f268,
      element: data == undefined ? <>-</> : <span className={formatCompareColor(data.f267, data.f266)}>{formatNumToFixed(data.f268, data.f265, data.f268 > 0 ? "+" : "", "%")}</span>,
    }
  },
  [quote_item_name.正股代码]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f262,
      text: data == undefined ? "-" : data.f262,
      element: data == undefined ? <>-</> : <span>{data.f262}</span>,
    }
  },
  [quote_item_name.正股现价]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f267,
      text: data == undefined ? "-" : data.f267,
      element: data == undefined ? <>-</> : <span className={formatCompareColor(data.f267, data.f266)}>{formatNumToFixed(data.f267, data.f265)}</span>,
    }
  },
  [quote_item_name.转债名称]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f264,
      text: data == undefined ? "-" : data.f264,
      element: data == undefined ? <>-</> : <span>{data.f264}</span>,
    }
  },
  [quote_item_name.转债最新价]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f267,
      text: data == undefined ? "-" : data.f267,
      element: data == undefined ? <>-</> : <span className={formatCompareColor(data.f267, data.f266)}>{formatNumToFixed(data.f267, data.f265)}</span>,
    }
  },
  [quote_item_name.转债涨跌幅]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f268,
      text: data == undefined ? "-" : data.f268,
      element: data == undefined ? <>-</> : <span className={formatCompareColor(data.f267, data.f266)}>{formatNumToFixed(data.f268, data.f152, data.f268 > 0 ? "+" : "", "%")}</span>,
    }
  },
  [quote_item_name.转债代码]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f262,
      text: data == undefined ? "-" : data.f262,
      element: data == undefined ? <>-</> : <span>{data.f262}</span>,
    }
  },
  [quote_item_name.可转债转股溢价率]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f290,
      text: data == undefined ? "-" : data.f290,
      element: data == undefined ? <>-</> : <span className={formatStockColor(data.f290, 0)}> {formatNumToFixed(data.f290, data.f152, "", "%")}</span>,
    }
  },
  [quote_item_name.转股价格]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f426,
      text: data == undefined ? "-" : data.f426,
      element: data == undefined ? <>-</> : <span>{formatNumToFixed(data.f426, data.f265)}</span>,
    }
  },
  [quote_item_name.纯债价值]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f424,
      text: data == undefined ? "-" : data.f424,
      element: data == undefined ? <>-</> : <span>{formatNumToFixed(data.f424, data.f154)}</span>,
    }
  },
  [quote_item_name.纯债溢价率]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f429,
      text: data == undefined ? "-" : data.f429,
      element: data == undefined ? <>-</> : <span>{formatNumToFixed(data.f429, data.f152, "", "%")}</span>,
    }
  },
  [quote_item_name.到期赎回价]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f432,
      text: data == undefined ? "-" : data.f432,
      element: data == undefined ? <>-</> : <span>{formatNumToFixed(data.f432, data.f265)}</span>,
    }
  },
  [quote_item_name.加权平均]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f71,
      text: data == undefined ? "-" : data.f71,
      element: data == undefined ? <>-</> : <p>{formatNumToFixed(data.f71, data.f59)}</p>,
    }
  },
  [quote_item_name.加权涨跌]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f705,
      text: data == undefined ? "-" : data.f705,
      element: data == undefined ? <>-</> : <p>{formatNumToFixed(data.f705, data.f152, "", " BP")}</p>,
    }
  },
  [quote_item_name.涨跌BP]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f169,
      text: data == undefined ? "-" : data.f169,
      element: data == undefined ? <>-</> : <span className={formatCompareColor(data.f169 * 100, data.f60)}>{formatUniqueNumToFixed(data.f169 * 100, data.f59, data.f152)}</span>,
      sh_bond_element: data == undefined ? <>-</> : <p>{formatNumToFixed(data.f704 / 100, data.f152)}</p>,
      new_bond_element: data == undefined ? <>-</> : <p>{formatNumToFixed(data.f704 / 100, data.f152)}</p>,
    }
  },
  [quote_item_name.昨加权]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f721,
      text: data == undefined ? "-" : data.f721,
      p_element: data == undefined ? <p>-</p> : <p>{formatNumToFixed(data.f721, data.f59)}</p>,
      span_element: data == undefined ? <span>-</span> : <span>{formatNumToFixed(data.f721, data.f59)}</span>,
    }
  },
  [quote_item_name.今加权]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f71,
      text: data == undefined ? "-" : data.f71,
      element: data == undefined ? <span>-</span> : <span className={formatCompareColor(data.f71, data.f60)}>{formatNumToFixed(data.f71, data.f59)}</span>,
    }
  },
  [quote_item_name.加权涨跌BP]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f705,
      text: data == undefined ? "-" : data.f705,
      element: data == undefined ? <span>-</span> : <span>{formatNumToFixed(data.f705, data.f152)}</span>,
    }
  },
  [quote_item_name.资金可用日]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f727,
      text: data == undefined ? "-" : data.f727,
      element:
        data == undefined ? (
          <span>-</span>
        ) : (
          <span className={getPanKouSmallScreenDeviceClass()}>
            {dateTransform(data.f727)}({FormatStringDate(dateTransform(data.f727))})
          </span>
        ),
      new_element: data == undefined ? <span>-</span> : <span className={getPanKouSmallScreenDeviceClass()}>{dateTransform(data.f727)}</span>,
    }
  },
  [quote_item_name.资金可取日]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f728,
      text: data == undefined ? "-" : data.f728,
      element:
        data == undefined ? (
          <span>-</span>
        ) : (
          <span className={getPanKouSmallScreenDeviceClass()}>
            {dateTransform(data.f728)}({FormatStringDate(dateTransform(data.f728))})
          </span>
        ),
      new_element: data == undefined ? <span>-</span> : <span className={getPanKouSmallScreenDeviceClass()}>{dateTransform(data.f728)}</span>,
    }
  },
  [quote_item_name.万元收益]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f724,
      text: data == undefined ? "-" : data.f724,
      element: data == undefined ? <span>-</span> : <span className={formatCompareColor(data.f724, data.f60)}>{formatUniqueNumToFixed(data.f724, data.f154, data.f59)}</span>,
      new_element: data == undefined ? <span>-</span> : <span>{formatUniqueNumToFixed(data.f724, data.f154, data.f154)}</span>,
    }
  },
  [quote_item_name.占款天数]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f725,
      text: data == undefined ? "-" : data.f725,
      element: data == undefined ? <span>-</span> : <span>{data.f725}</span>,
    }
  },
  [quote_item_name.借用天数]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f726,
      text: data == undefined ? "-" : data.f726,
      element: data == undefined ? <span>-</span> : <span>{data.f726}</span>,
    }
  },
  [quote_item_name.最新YTM]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f703,
      text: data == undefined ? "-" : data.f703,
      element: data == undefined ? <p>-</p> : <p>{formatUniqueNumToFixed(data.f703, data.f154, data.f152, "%")}</p>,
      new_element: data == undefined ? <span>-</span> : <span>{formatUniqueNumToFixed(data.f703, data.f154, data.f152, "%")}</span>,
    }
  },
  [quote_item_name.最近成交方式]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f706,
      text: data == undefined ? "-" : data.f706,
      element: data == undefined ? <p>-</p> : <p>{returnTransactionMode(data.f706)}</p>,
      pkElement: data == undefined ? <span>-</span> : <span>{returnTransactionMode(data.f706)}</span>,
    }
  },
  [quote_item_name.匹配成交价]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f700,
      text: data == undefined ? "-" : data.f700,
      element: data == undefined ? <span>-</span> : <span className={formatCompareColor(data.f700, data.f60)}>{formatNumToFixed(data.f700, data.f59)}</span>,
    }
  },
  [quote_item_name.匹配成交量]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f701,
      text: data == undefined ? "-" : data.f701,
      element: data == undefined ? <span>-</span> : <span>{formatBigNumber(data.f701, data.f59)}</span>,
      new_element: data == undefined ? <span>-</span> : <span>{data.f701}</span>,
      pkElement: data == undefined ? <span>-</span> : <span>{formatUniqueNumToFixed(data.f701, 0, data.f59)}</span>,
    }
  },
  [quote_item_name.匹配成交涨幅]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f731,
      text: data == undefined ? "-" : data.f731,
      element: data == undefined ? <span>-</span> : <span className={formatSingleColor(data.f731)}>{formatNumToFixed(data.f731, data.f152, "", "%")}</span>,
    }
  },
  [quote_item_name.匹配成交额]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f702,
      text: data == undefined ? "-" : data.f702,
      element: data == undefined ? <span>-</span> : <span>{formatBigNumber(data.f702, data.f59)}</span>,
    }
  },
  [quote_item_name.全价]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f722,
      text: data == undefined ? "-" : data.f722,
      element: data == undefined ? <span>-</span> : <span>{formatNumToFixed(data.f722, data.f59)}</span>,
    }
  },
  [quote_item_name.债券类型]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f182,
      text: data == undefined ? "-" : data.f182,
      element: data == undefined ? <span>-</span> : <span>{BondType[getBondDetailType()]}</span>,
    }
  },
  [quote_item_name.应付利息]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f707,
      text: data == undefined ? "-" : data.f707,
      element: data == undefined ? <span>-</span> : <span>{formatUniqueNumToFixed(data.f707, 0, 4)}</span>,
    }
  },
  [quote_item_name.面值]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f720,
      text: data == undefined ? "-" : data.f720,
      element: data == undefined ? <span>-</span> : <span>{formatUniqueNumToFixed(data.f720, 0, 2)}</span>,
    }
  },
  [quote_item_name.发行规模]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f719,
      text: data == undefined ? "-" : data.f719,
      element: data == undefined ? <span>-</span> : <span>{formatUniqueNumToFixed(data.f719, 0, 3, "亿")}</span>,
    }
  },
  [quote_item_name.上市日期]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f189,
      text: data == undefined ? "-" : data.f189,
      element: data == undefined ? <span>-</span> : <span>{dateTransform(data.f189)}</span>,
    }
  },
  [quote_item_name.票面利率]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f423,
      text: data == undefined ? "-" : data.f423,
      element: data == undefined ? <span>-</span> : <span>{formatNumToFixed(data.f423, data.f152)}</span>,
    }
  },
  [quote_item_name.到期日]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f717,
      text: data == undefined ? "-" : data.f717,
      element: data == undefined ? <span>-</span> : <span>{dateTransform(data.f717)}</span>,
    }
  },
  [quote_item_name.剩余年限]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f711,
      text: data == undefined ? "-" : data.f711,
      element: data == undefined ? <span>-</span> : <span>{formatUniqueNumToFixed(data.f711, 0, 2, "年")}</span>,
    }
  },
  [quote_item_name.付息日]: function (data: any) {
    return {
      // 多个字段 f713、f714、f715、f716
      source: data == undefined ? "-" : data.f713,
      text: data == undefined ? "-" : data.f713,
      element: data == undefined ? <span>-</span> : <span>{dateAllTransform(data.f713, data.f714, data.f715, data.f716)}</span>,
    }
  },
  [quote_item_name.距付息日天数]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f712,
      text: data == undefined ? "-" : data.f712,
      element: data == undefined ? <span>-</span> : <span>{data.f712}</span>,
    }
  },
  [quote_item_name.付息方式]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f710,
      text: data == undefined ? "-" : data.f710,
      element: data == undefined ? <>-</> : <span className={getFxfs(data.f710).length > 6 ? "special-font" : ""}>{getSpecialFxfs(getFxfs(data.f710))}</span>,
    }
  },
  [quote_item_name.折合标准券]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f718,
      text: data == undefined ? "-" : data.f718,
      element: data == undefined ? <span>-</span> : <span>{formatUniqueNumToFixed(data.f718, 0, 2)}</span>,
      new_element: data == undefined ? <span>-</span> : <span>{formatUniqueNumToFixed(data.f718, 0, data.f59)}</span>,
    }
  },
  [quote_item_name.息票品种]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f708,
      text: data == undefined ? "-" : data.f708,
      element: data == undefined ? <span>-</span> : <span>{getXppz(data.f708)}</span>,
    }
  },
  [quote_item_name.港股本]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f85,
      text: data == undefined ? "-" : data.f85,
      element: data == undefined ? <span>-</span> : <span>{formatUnit(data.f85, "calc", 2)}</span>,
    }
  },
  [quote_item_name.港值]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f117,
      text: data == undefined ? "-" : data.f117,
      element: data == undefined ? <span>-</span> : <span>{formatUnit(data.f117, "calc", 2)}</span>,
    }
  },
  [quote_item_name["A/B股报价"]]: function (data: any) {
    let percent = data ? formatNumToFixed(data.f275, data.f152) : "-"
    let color = percent == "-" || percent == 0 ? "black" : percent > 0 ? "red" : "green"
    percent = percent > 0 ? `${percent}%` : percent < 0 ? `${percent}%` : "0.00%"
    return {
      element:
        data == undefined ? (
          <span>-</span>
        ) : (
          <span className={color}>
            {formatNumToFixed(data.f274, data.f272)}&nbsp;&nbsp;{percent}
          </span>
        ),
    }
  },
  [quote_item_name["(A/B)比价"]]: function (data: any) {
    const comparsion = data ? formatNumToFixed(data.f276, data.f152) : "-"
    return {
      element: data == undefined ? <span>-</span> : <span className={comparsion == "-" ? "black" : comparsion > 1 ? "red" : "green"}>{comparsion}</span>,
    }
  },
  [quote_item_name["(B/A)比价"]]: function (data: any) {
    const comparsion = data && isNumber(data.f276) && data.f276 != 0 ? formatNumToFixed((1 / formatNumToFixed(data.f276, data.f152)) * Math.pow(10, data.f152), data.f152) : "-"
    return {
      element: data == undefined ? <span>-</span> : <span className={comparsion == "-" ? "black" : comparsion > 1 ? "red" : "green"}>{comparsion}</span>,
    }
  },
  [quote_item_name.成交量单位]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f106,
      text: data == undefined ? "-" : data.f106,
      element: data == undefined ? <span>-</span> : <span>{data.f106}</span>,
    }
  },
  [quote_item_name.成交量单位_港股]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f602,
      text: data == undefined ? "-" : data.f602,
      element: data == undefined ? <span>-</span> : <span>{data.f602}</span>,
    }
  },
  [quote_item_name.点差]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f39 - data.f19,
      text: data == undefined || data?.f39 == "-" || data?.f19 == "-" ? "-" : data.f39 - data.f19,
      element: data == undefined || data?.f39 == "-" || data?.f19 == "-" ? <span>-</span> : <span>{data.f39 - data.f19}</span>,
      cny_element: <span>0</span>,
    }
  },
  [quote_item_name["10日涨跌幅"]]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f291,
      text: data == undefined ? "-" : formatNumToFixed(data.f291, data.f152, "", "%"),
      element: data == undefined ? <span>-</span> : <span className={`${formatCompareColor(data.f291,0)}`}>{formatNumToFixed(data.f291, data.f152, "", "%")}</span>,
    }
  },
  [quote_item_name["20日涨跌幅"]]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f120,
      text: data == undefined ? "-" : formatNumToFixed(data.f120, data.f152, "", "%"),
      element: data == undefined ? <span>-</span> : <span className={`${formatCompareColor(data.f120,0)}`}>{formatNumToFixed(data.f120, data.f152, "", "%")}</span>,
    }
  },
  [quote_item_name["60日涨跌幅"]]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f121,
      text: data == undefined ? "-" : formatNumToFixed(data.f121, data.f152, "", "%"),
      element: data == undefined ? <span>-</span> : <span className={`${formatCompareColor(data.f121,0)}`}>{formatNumToFixed(data.f121, data.f152, "", "%")}</span>,
    }
  },
  [quote_item_name.今年来涨跌幅]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f122,
      text: data == undefined ? "-" : formatNumToFixed(data.f122, data.f152, "", "%"),
      element: data == undefined ? <span>-</span> : <span className={`${formatCompareColor(data.f122,0)}`}>{formatNumToFixed(data.f122, data.f152, "", "%")}</span>,
    }
  },
  [quote_item_name.买1价]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f19,
      text: data == undefined ? "-" : formatNumToFixed(data.f19, data.f59),
      element: data == undefined ? <span>-</span> : <span className={`${formatCompareColor(data.f19, data.f60)}`}>{formatNumToFixed(data.f19, data.f59)}</span>,
      tips_element: data == undefined ? <span>-</span> : <span className={`${formatTipsCompareColor(data.f19, data.f60)}`}>{formatNumToFixed(data.f19, data.f59)}</span>,
    }
  },
  [quote_item_name.卖1价]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f39,
      text: data == undefined ? "-" : formatNumToFixed(data.f39, data.f59),
      element: data == undefined ? <span>-</span> : <span className={`${formatCompareColor(data.f39, data.f60)}`}>{formatNumToFixed(data.f39, data.f59)}</span>,
      tips_element: data == undefined ? <span>-</span> : <span className={`${formatTipsCompareColor(data.f39, data.f60)}`}>{formatNumToFixed(data.f39, data.f59)}</span>,
    }
  },
  [quote_item_name.价差]: function (data: any) {
    return {
      source: data == undefined ? "-" : (data?.f19 - data?.f39) * 100,
      text: data == undefined ? "-" : formatNumToFixed(data.f39, data.f59),
      element: data == undefined || !data.f19 || !data.f39 ? <span>-</span> : <span>{formatUniqueNumToFixed((data.f19 - data.f39) * 100, data.f59, 2, "BP")}</span>,
    }
  },
  [quote_item_name.买1量]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f20,
      text: data == undefined ? "-" : data.f20,
      element: data == undefined ? <span>-</span> : <span>{data.f20 ?? "-"}</span>,
    }
  },
  [quote_item_name.卖1量]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f40,
      text: data == undefined ? "-" : data.f40,
      element: data == undefined ? <span>-</span> : <span>{data.f40 ?? "-"}</span>,
    }
  },
  [quote_item_name.个券价差]: function (data: any) {
    return {
      source: data == undefined ? "-" : (data.f764 - data.f763) * 100,
      text: data == undefined ? "-" : formatNumToFixed(data.f764 - data.f763, data.f59),
      element: data == undefined || data.f19 == "-" || data.f39 == "-" ? <span>-</span> : <span>{formatUniqueNumToFixed((data.f764 - data.f763) * 100, data.f59, 2, "BP")}</span>,
    }
  },
  [quote_item_name.关键期限价差]: function (data: any) {
    return {
      source: data == undefined ? "-" : (data?.f19 - data?.f39) * 100,
      text: data == undefined ? "-" : formatNumToFixed(data.f39, data.f59),
      element: data == undefined || data.f19 == "-" || data.f39 == "-" ? <span>-</span> : <span>{formatUniqueNumToFixed((data.f19 - data.f39) * 100, data.f59, 2, "BP")}</span>,
    }
  },
  [quote_item_name.计息天数]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f725,
      text: data == undefined ? "-" : data.f725,
      element: data == undefined ? <p>-</p> : <p>{formatNumToFixed(data.f725, 0, "", "天")}</p>,
    }
  },
  [quote_item_name.千元收益]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f246,
      text: data == undefined ? "-" : data.f246,
      element: data == undefined ? <p>-</p> : <p>{formatNumToFixed(data.f246, data.f154)}</p>,
    }
  },
  [quote_item_name.港股双柜台最新价]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f43,
      text: data == undefined ? "-" : data.f43,
      element: data == undefined ? <span>-</span> : <span className={formatCompareColor(data.f43, data.f60)}>{formatNumToFixed(data.f43, data.f59)}</span>,
    }
  },
  [quote_item_name.港股双柜台涨跌幅]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f170,
      text: data == undefined ? "-" : data.f170,
      element: data == undefined ? <span>-</span> : <span className={formatCompareColor(data.f43, data.f60)}>{formatNumToFixed(data.f170, data.f152, "", "%")}</span>,
    }
  },
  [quote_item_name.国债所属国家代码]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f753,
      text: data == undefined ? "-" : data.f753,
      element: data == undefined ? <span>-</span> : <span>{data.f753}</span>,
    }
  },
  [quote_item_name.国债所属国家名称]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f759,
      text: data == undefined ? "-" : data.f759,
      element: data == undefined ? <span>-</span> : <span>{data.f759 ?? "-"}</span>,
    }
  },
  // [quote_item_name.国债关键期限]: function (data: any) {
  //   return {
  //     source: data == undefined ? "-" : data.f754,
  //     text: data == undefined ? "-" : data.f754,
  //     element: data == undefined ? <span>-</span> : <span>{data.f754}</span>,
  //   }
  // },
  // [quote_item_name.国债更新时间]: function (data: any) {
  //   return {
  //     source: data == undefined ? "-" : data.f86,
  //     text: data == undefined ? "-" : data.f86,
  //     element: data == undefined ? <span>-</span> : <span>{formatDate(data.f86 * 1000, "hh:mmm:ss") ? formatDate(data.f86 * 1000, "hh:mmm:ss") + " 北京" : "-"}</span>,
  //   }
  // },
  [quote_item_name.国债剩余年限]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f755,
      text: data == undefined ? "-" : data.f755,
      element: data == undefined ? <span>-</span> : <span>{data.f755 ?? "-"}</span>,
    }
  },
  [quote_item_name.国债到期日期]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f758,
      text: data == undefined ? "-" : data.f758,
      element: data == undefined ? <span>-</span> : <span className={`${getLongDataScaleClass(380, "tips-date")}`}>{formatDate(data.f758 * 1000, "yyyy-MM-dd") ? formatDate(data.f758 * 1000, "yyyy-MM-dd") : "-"}</span>,
      pk_element: data == undefined ? <span>-</span> : <span>{formatDate(data.f758 * 1000, "yyyy-MM-dd") ? formatDate(data.f758 * 1000, "yyyy-MM-dd") : "-"}</span>,
    }
  },
  [quote_item_name.国债涨跌BP]: function (data: any) {
    return {
      source: data == undefined || data.f51 == "-" || data.f52 == "-" ? "-" : (data.f51 - data.f52) * 100,
      text: data == undefined || data.f51 == "-" || data.f52 == "-" ? "-" : (data.f51 - data.f52) * 100,
      element: data == undefined || data.f51 == "-" || data.f52 == "-" ? <span>-</span> : <span>{formatUniqueNumToFixed((data.f51 - data.f52) * 100, data.f154, 2, "BP")}</span>,
    }
  },
  [quote_item_name.国债票面利率]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f761,
      text: data == undefined ? "-" : data.f761,
      element: data == undefined ? <span>-</span> : <span>{formatUniqueNumToFixed(data.f761, 0, 3, "%")}</span>,
    }
  },
  [quote_item_name.国债最新YTM]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f51,
      text: data == undefined ? "-" : data.f51,
      element: data == undefined ? <span>-</span> : <span>{formatUniqueNumToFixed(data.f761, 0, data.f152, "%")}</span>,
    }
  },
  [quote_item_name.国债最优买YTM]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f764,
      text: data == undefined ? "-" : data.f764,
      element: data == undefined ? <span>-</span> : <span>{formatNumToFixed(data.f764, data.f59) ?? "-"}</span>,
    }
  },
  [quote_item_name.国债最优卖YTM]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f763,
      text: data == undefined ? "-" : data.f763,
      element: data == undefined ? <span>-</span> : <span>{formatNumToFixed(data.f763, data.f59) ?? "-"}</span>,
    }
  },
  [quote_item_name.国债关键期限]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f754,
      text: data == undefined ? "-" : data.f754,
      element: data == undefined ? <span>-</span> : <span>{data.f754}</span>,
    }
  },
  [quote_item_name.国债更新时间]: function (data: any) {
    return {
      source: data == undefined ? "-" : data.f86,
      text: data == undefined ? "-" : data.f86,
      element: data == undefined ? <span>-</span> : <span>{formatDate(new Date(data.f86 * 1000), "hh:mmm:ss") ? formatDate(new Date(data.f86 * 1000), "hh:mmm:ss") + " 北京" : "-"}</span>,
    }
  },
  [quote_item_name.GDR报价]: function (data: any) {
    let percent = data ? formatNumToFixed(data.f744, data.f152) : "-"
    let color = percent == "-" || percent == 0 ? "black" : percent > 0 ? "red" : "green"
    percent = percent > 0 ? `${percent}%` : percent < 0 ? `${percent}%` : "0.00%"
    return {
      element:
        data == undefined ? (
          <>-</>
        ) : (
          <span className={color}>
            {data.f743 == "-" ? "--" : formatNumToFixed(data.f743, data.f746)}&nbsp;&nbsp;{percent}
          </span>
        ),
    }
  },
  [quote_item_name["(A/GDR)比价"]]: function (data: any) {
    const comparsion = data ? formatNumToFixed(data.f750, data.f152) : "-"
    return {
      element: data == undefined ? <>-</> : <span className={comparsion == "-" ? "black" : comparsion > 1 ? "red" : "green"}>{comparsion == "-" ? " --" : comparsion}</span>,
    }
  },
}

export const getSmallScreenDeviceClass = () => {
  if (window.innerWidth < 380) {
    return "small-screen-device"
  } else {
    return ""
  }
}

export const getPanKouSmallScreenDeviceClass = () => {
  if (window.innerWidth < 365) {
    return "special-font"
  } else {
    return ""
  }
}

export const getScaleClass = () => {
  if (window.innerWidth < 350) {
    return "scale-second-level"
  } else {
    return ""
  }
}

export const getLongDataScaleClass = (width: number, className: string) => {
  if (window.innerWidth < width) {
    return `scale-first-level ${className}`
  } else {
    return ""
  }
}

export const setLongDataClass = (width: number, className: string) => {
  if (window.innerWidth < width) {
    return className
  } else {
    return ""
  }
}

export let quote_chart = {
  [quote_item_name.最新价]: function (price: number, zde: number, color = "") {
    return {
      element: <span className={quoteColor(zde)}>{price}</span>,
      new_element: <p className={color}>{price}</p>,
      bond_element: <p className={color}>{price}</p>,
    }
  },
  [quote_item_name.涨跌幅]: function (zdf: string, zde: number, color = "") {
    return {
      element: <span className={quoteColor(zde)}>{zdf}</span>,
      scale_element: <span className={`${quoteColor(zde)} ${String(zdf).length > 7 ? "scale-first-level" : ""}`}>{zdf}</span>,
      hk_element: <span className={`${quoteColor(zde)} ${String(zdf).length > 5 ? "hk-scale-first-level" : ""}`}>{zdf}</span>,
      new_element: <span className={color}>{zdf}</span>,
      bond_element: <span className={color}>{zdf}</span>,
    }
  },
  [quote_item_name.涨跌额]: function (zde: any, color = "") {
    return {
      element: <span className={quoteColor(zde)}>{zde}</span>,
      scale_element: <span className={`${quoteColor(zde)} ${String(zde).length >= 6 ? "scale-first-level" : ""}`}>{zde}</span>,
      hk_element: <span className={`${quoteColor(zde)} ${String(zde).length >= 6 ? "hk-scale-first-level" : ""}`}>{zde}</span>,
      new_element: <span className={color}>{zde}</span>,
      bond_element: <span className={color}>{zde}</span>,
    }
  },
  [quote_item_name.今开]: function (jk: string, jkColor: string) {
    return {
      element: <span className={jkColor}>{jk}</span>,
    }
  },
  [quote_item_name.昨收]: function (zs: string) {
    return {
      element: <span>{zs}</span>,
    }
  },
  [quote_item_name.最高]: function (maxPrice: string, maxPriceColor: string) {
    return {
      element: <span className={maxPriceColor}>{maxPrice}</span>,
    }
  },
  [quote_item_name.最低]: function (minPrice: string, minPriceColor: string) {
    return {
      element: <span className={minPriceColor}>{minPrice}</span>,
    }
  },
  [quote_item_name.换手]: function (hs: string) {
    return {
      element: <span>{hs}</span>,
    }
  },
  [quote_item_name.振幅]: function (zf: string) {
    return {
      element: <span>{zf}</span>,
    }
  },
  [quote_item_name.均价]: function (jj: string, color: string) {
    return {
      element: <span className={color}>{jj}</span>,
    }
  },
  [quote_item_name.总手]: function (zs: string) {
    return {
      element: <span>{zs}</span>,
      new_element: <span className={getLongDataScaleClass(395, "")}>{zs}</span>,
    }
  },
  [quote_item_name.持仓]: function (cc: string) {
    return {
      element: <span>{cc}</span>,
    }
  },
  [quote_item_name.日增]: function (rz: string, rzColor: string) {
    return {
      element: <span className={rzColor}>{rz}</span>,
    }
  },
  [quote_item_name.结算]: function (js: string, jiesuanColor: string) {
    return {
      element: <span className={jiesuanColor}>{js}</span>,
    }
  },
  [quote_item_name.昨结]: function (zj: string) {
    return {
      element: <span>{zj}</span>,
    }
  },
  [quote_item_name.成交量]: function (volume: string) {
    return {
      element: <span className={getScaleClass()}>{formatBigNumber(volume, 2)}</span>,
    }
  },
  [quote_item_name.成交额]: function (amount: string) {
    return {
      element: <span className={getScaleClass()}>{amount}</span>,
      bond_element: <span className={getScaleClass()}>{formatBigNumber(amount, 2)}</span>,
      new_bond_element: <span className={getScaleClass()}>{formatBigNumber(amount, window.innerWidth < 330 ? 1 : 2)}</span>,
    }
  },
  [quote_item_name.总市值]: function (data: any) {
    return {
      element: <span>{formatBigNumber(data.f116, data.f59)}</span>,
      hk_element: <span>{formatBigNumber(data.f116, 2)}</span>,
    }
  },
  [quote_item_name.流通市值]: function (data: any) {
    return {
      element: <span>{formatBigNumber(data.f117, data.f59)}</span>,
    }
  },
  [quote_item_name["52周最高价"]]: function (data: any) {
    return {
      element: data == undefined ? <>-</> : <span className={getLongDataScaleClass(380, "")}>{formatNumToFixed(data.f174, data.f59)}</span>,
      colored_element: data == undefined ? <>-</> : <span className={`${getLongDataScaleClass(380, "")} ${formatCompareColor(data.f174, data.f60)}`}>{formatNumToFixed(data.f174, data.f59)}</span>,
    }
  },
  [quote_item_name["52周最低价"]]: function (data: any) {
    return {
      element: data == undefined ? <>-</> : <span className={getLongDataScaleClass(380, "long-data-position")}>{formatNumToFixed(data.f175, data.f59)}</span>,
      colored_element: data == undefined ? <>-</> : <span className={`${getLongDataScaleClass(380, "long-data-position")} ${formatCompareColor(data.f175, data.f60)}`}>{formatNumToFixed(data.f175, data.f59)}</span>,
    }
  },
  [quote_item_name.市盈率]: function (data: any) {
    return {
      element: <span>{formatNumToFixed(data.f164, data.f152)}</span>,
    }
  },
  [quote_item_name["市盈率(动)"]]: function (data: any) {
    return {
      element: <span>{formatNumToFixed(data.f162, data.f152)}</span>,
    }
  },
  [quote_item_name.市净率]: function (data: any) {
    return {
      element: <span>{formatNumToFixed(data.f167, data.f152)}</span>,
    }
  },
  [quote_item_name.日K时间]: function (data: any) {
    return {
      element: <span className="k-time">{data ?? "-"}</span>,
    }
  },
  [quote_item_name.盘后量]: function (data: any) {
    return {
      element: <span>{data.phvolume}</span>,
    }
  },
  [quote_item_name.盘后额]: function (data: any) {
    return {
      element: <span>{data.phamount}</span>,
    }
  },
  [quote_item_name.量比]: function (liangbi: any) {
    return {
      element: <span>{liangbi}</span>,
    }
  },
}

export let quote_trade_info = {
  [quote_item_trade_info.卖1价]: function (data: any) {
    let sellPrice = formatNumToFixed(data.f39, data.f59)
    return {
      element: <span className={`${formatCompareColor(data.f39, data.f60)} ${sellPrice && sellPrice.length > 7 ? "trans-scale" : ""}`}>{sellPrice ?? "-"}</span>,
      hk_element: <span className={`${sellPrice && sellPrice.length > 8 ? "trans-scale" : ""} ${formatHKTimeTradeColor(data.f39, data.f60)}`}>{sellPrice ?? "-"}</span>,
      tips_element: <span className={`${formatCompareColor(data.f39, data.f60)} ${sellPrice && sellPrice.length > 6 ? "trans-scale" : ""}`}>{sellPrice ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.卖1量]: function (data: any) {
    return {
      element: <span>{data.f40 ?? "-"}</span>,
      hk_element: <span>{formatHKBigNumber(data.f40) ?? "-"}</span>,
      bond_element: <span>{formatHKBigNumber(data.f40) ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.买1价]: function (data: any) {
    let buyPrice = formatNumToFixed(data.f19, data.f59)
    return {
      element: <span className={`${formatCompareColor(data.f19, data.f60)} ${buyPrice && buyPrice.length > 7 ? "trans-scale" : ""}`}>{buyPrice ?? "-"}</span>,
      hk_element: <span className={`${buyPrice && buyPrice.length > 8 ? "trans-scale" : ""} ${formatHKTimeTradeColor(data.f19, data.f60)}`}>{buyPrice ?? "-"}</span>,
      tips_element: <span className={`${formatCompareColor(data.f19, data.f60)} ${buyPrice && buyPrice.length > 6 ? "trans-scale" : ""}`}>{buyPrice ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.买1量]: function (data: any) {
    return {
      element: <span>{data.f20 ?? "-"}</span>,
      hk_element: <span>{formatHKBigNumber(data.f20) ?? "-"}</span>,
      bond_element: <span>{formatHKBigNumber(data.f20) ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.卖2价]: function (data: any) {
    let sellPrice = formatNumToFixed(data.f37, data.f59)
    return {
      element: <span className={`${formatCompareColor(data.f37, data.f60)} ${sellPrice && sellPrice.length > 7 ? "trans-scale" : ""}`}>{sellPrice ?? "-"}</span>,
      hk_element: <span className={`${sellPrice && sellPrice.length > 8 ? "trans-scale" : ""} ${formatHKTimeTradeColor(data.f37, data.f60)}`}>{sellPrice ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.卖2量]: function (data: any) {
    return {
      element: <span>{data.f38 ?? "-"}</span>,
      hk_element: <span>{formatHKBigNumber(data.f38) ?? "-"}</span>,
      bond_element: <span>{formatHKBigNumber(data.f38) ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.买2价]: function (data: any) {
    let buyPrice = formatNumToFixed(data.f17, data.f59)
    return {
      element: <span className={`${formatCompareColor(data.f17, data.f60)} ${buyPrice && buyPrice.length > 7 ? "trans-scale" : ""}`}>{buyPrice ?? "-"}</span>,
      hk_element: <span className={`${buyPrice && buyPrice.length > 8 ? "trans-scale" : ""} ${formatHKTimeTradeColor(data.f17, data.f60)}`}>{buyPrice ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.买2量]: function (data: any) {
    return {
      element: <span>{data.f18 ?? "-"}</span>,
      hk_element: <span>{formatHKBigNumber(data.f18) ?? "-"}</span>,
      bond_element: <span>{formatHKBigNumber(data.f18) ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.卖3价]: function (data: any) {
    let sellPrice = formatNumToFixed(data.f35, data.f59)
    return {
      element: <span className={`${formatCompareColor(data.f35, data.f60)} ${sellPrice && sellPrice.length > 7 ? "trans-scale" : ""}`}>{sellPrice ?? "-"}</span>,
      hk_element: <span className={`${sellPrice && sellPrice.length > 8 ? "trans-scale" : ""} ${formatHKTimeTradeColor(data.f35, data.f60)}`}>{sellPrice ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.卖3量]: function (data: any) {
    return {
      element: <span>{data.f36 ?? "-"}</span>,
      hk_element: <span>{formatHKBigNumber(data.f36) ?? "-"}</span>,
      bond_element: <span>{formatHKBigNumber(data.f36) ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.买3价]: function (data: any) {
    let buyPrice = formatNumToFixed(data.f15, data.f59)
    return {
      element: <span className={`${formatCompareColor(data.f15, data.f60)} ${buyPrice && buyPrice.length > 7 ? "trans-scale" : ""}`}>{buyPrice ?? "-"}</span>,
      hk_element: <span className={`${buyPrice && buyPrice.length > 8 ? "trans-scale" : ""} ${formatHKTimeTradeColor(data.f15, data.f60)}`}>{buyPrice ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.买3量]: function (data: any) {
    return {
      element: <span>{data.f16 ?? "-"}</span>,
      hk_element: <span>{formatHKBigNumber(data.f16) ?? "-"}</span>,
      bond_element: <span>{formatHKBigNumber(data.f16) ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.卖4价]: function (data: any) {
    let sellPrice = formatNumToFixed(data.f33, data.f59)
    return {
      element: <span className={`${formatCompareColor(data.f33, data.f60)} ${sellPrice && sellPrice.length > 7 ? "trans-scale" : ""}`}>{sellPrice ?? "-"}</span>,
      hk_element: <span className={`${sellPrice && sellPrice.length > 8 ? "trans-scale" : ""} ${formatHKTimeTradeColor(data.f33, data.f60)}`}>{sellPrice ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.卖4量]: function (data: any) {
    return {
      element: <span>{data.f34 ?? "-"}</span>,
      hk_element: <span>{formatHKBigNumber(data.f34) ?? "-"}</span>,
      bond_element: <span>{formatHKBigNumber(data.f34) ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.买4价]: function (data: any) {
    let buyPrice = formatNumToFixed(data.f13, data.f59)
    return {
      element: <span className={`${formatCompareColor(data.f13, data.f60)} ${buyPrice && buyPrice.length > 7 ? "trans-scale" : ""}`}>{buyPrice ?? "-"}</span>,
      hk_element: <span className={`${buyPrice && buyPrice.length > 8 ? "trans-scale" : ""} ${formatHKTimeTradeColor(data.f13, data.f60)}`}>{buyPrice ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.买4量]: function (data: any) {
    return {
      element: <span>{data.f14 ?? "-"}</span>,
      hk_element: <span>{formatHKBigNumber(data.f14) ?? "-"}</span>,
      bond_element: <span>{formatHKBigNumber(data.f14) ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.卖5价]: function (data: any) {
    let sellPrice = formatNumToFixed(data.f31, data.f59)
    return {
      element: <span className={`${formatCompareColor(data.f31, data.f60)} ${sellPrice && sellPrice.length > 7 ? "trans-scale" : ""}`}>{sellPrice ?? "-"}</span>,
      hk_element: <span className={`${sellPrice && sellPrice.length > 8 ? "trans-scale" : ""} ${formatHKTimeTradeColor(data.f31, data.f60)}`}>{sellPrice ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.卖5量]: function (data: any) {
    return {
      element: <span>{data.f32 ?? "-"}</span>,
      hk_element: <span>{formatHKBigNumber(data.f32) ?? "-"}</span>,
      bond_element: <span>{formatHKBigNumber(data.f32) ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.买5价]: function (data: any) {
    let buyPrice = formatNumToFixed(data.f11, data.f59)
    return {
      element: <span className={`${formatCompareColor(data.f11, data.f60)} ${buyPrice && buyPrice.length > 7 ? "trans-scale" : ""}`}>{buyPrice ?? "-"}</span>,
      hk_element: <span className={`${buyPrice && buyPrice.length > 8 ? "trans-scale" : ""} ${formatHKTimeTradeColor(data.f11, data.f60)}`}>{buyPrice ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.买5量]: function (data: any) {
    return {
      element: <span>{data.f12 ?? "-"}</span>,
      hk_element: <span>{formatHKBigNumber(data.f12) ?? "-"}</span>,
      bond_element: <span>{formatHKBigNumber(data.f12) ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.卖6价]: function (data: any) {
    let sellPrice = formatNumToFixed(data.f29, data.f59)
    return {
      element: <span className={`${formatCompareColor(data.f29, data.f60)} ${sellPrice && sellPrice.length > 7 ? "trans-scale" : ""}`}>{sellPrice ?? "-"}</span>,
      hk_element: <span className={`${sellPrice && sellPrice.length > 8 ? "trans-scale" : ""} ${formatHKTimeTradeColor(data.f29, data.f60)}`}>{sellPrice ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.卖6量]: function (data: any) {
    return {
      element: <span>{data.f30 ?? "-"}</span>,
      hk_element: <span>{formatHKBigNumber(data.f30) ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.买6价]: function (data: any) {
    let buyPrice = formatNumToFixed(data.f9, data.f59)
    return {
      element: <span className={`${formatCompareColor(data.f9, data.f60)} ${buyPrice && buyPrice.length > 7 ? "trans-scale" : ""}`}>{buyPrice ?? "-"}</span>,
      hk_element: <span className={`${buyPrice && buyPrice.length > 8 ? "trans-scale" : ""} ${formatHKTimeTradeColor(data.f9, data.f60)}`}>{buyPrice ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.买6量]: function (data: any) {
    return {
      element: <span>{data.f10 ?? "-"}</span>,
      hk_element: <span>{formatHKBigNumber(data.f10) ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.卖7价]: function (data: any) {
    let sellPrice = formatNumToFixed(data.f27, data.f59)
    return {
      element: <span className={`${formatCompareColor(data.f27, data.f60)} ${sellPrice && sellPrice.length > 7 ? "trans-scale" : ""}`}>{sellPrice ?? "-"}</span>,
      hk_element: <span className={`${sellPrice && sellPrice.length > 8 ? "trans-scale" : ""} ${formatHKTimeTradeColor(data.f27, data.f60)}`}>{sellPrice ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.卖7量]: function (data: any) {
    return {
      element: <span>{data.f28 ?? "-"}</span>,
      hk_element: <span>{formatHKBigNumber(data.f28) ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.买7价]: function (data: any) {
    let buyPrice = formatNumToFixed(data.f7, data.f59)
    return {
      element: <span className={`${formatCompareColor(data.f7, data.f60)} ${buyPrice && buyPrice.length > 7 ? "trans-scale" : ""}`}>{buyPrice ?? "-"}</span>,
      hk_element: <span className={`${buyPrice && buyPrice.length > 8 ? "trans-scale" : ""} ${formatHKTimeTradeColor(data.f7, data.f60)}`}>{buyPrice ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.买7量]: function (data: any) {
    return {
      element: <span>{data.f8 ?? "-"}</span>,
      hk_element: <span>{formatHKBigNumber(data.f8) ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.卖8价]: function (data: any) {
    let sellPrice = formatNumToFixed(data.f25, data.f59)
    return {
      element: <span className={`${formatCompareColor(data.f25, data.f60)} ${sellPrice && sellPrice.length > 7 ? "trans-scale" : ""}`}>{sellPrice ?? "-"}</span>,
      hk_element: <span className={`${sellPrice && sellPrice.length > 8 ? "trans-scale" : ""} ${formatHKTimeTradeColor(data.f25, data.f60)}`}>{sellPrice ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.卖8量]: function (data: any) {
    return {
      element: <span>{data.f26 ?? "-"}</span>,
      hk_element: <span>{formatHKBigNumber(data.f26) ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.买8价]: function (data: any) {
    let buyPrice = formatNumToFixed(data.f5, data.f59)
    return {
      element: <span className={`${formatCompareColor(data.f5, data.f60)} ${buyPrice && buyPrice.length > 7 ? "trans-scale" : ""}`}>{buyPrice ?? "-"}</span>,
      hk_element: <span className={`${buyPrice && buyPrice.length > 8 ? "trans-scale" : ""} ${formatHKTimeTradeColor(data.f5, data.f60)}`}>{buyPrice ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.买8量]: function (data: any) {
    return {
      element: <span>{data.f6 ?? "-"}</span>,
      hk_element: <span>{formatHKBigNumber(data.f6) ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.卖9价]: function (data: any) {
    let sellPrice = formatNumToFixed(data.f23, data.f59)
    return {
      element: <span className={`${formatCompareColor(data.f23, data.f60)} ${sellPrice && sellPrice.length > 7 ? "trans-scale" : ""}`}>{sellPrice ?? "-"}</span>,
      hk_element: <span className={`${sellPrice && sellPrice.length > 8 ? "trans-scale" : ""} ${formatHKTimeTradeColor(data.f23, data.f60)}`}>{sellPrice ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.卖9量]: function (data: any) {
    return {
      element: <span>{data.f24 ?? "-"}</span>,
      hk_element: <span>{formatHKBigNumber(data.f24) ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.买9价]: function (data: any) {
    let buyPrice = formatNumToFixed(data.f3, data.f59)
    return {
      element: <span className={`${formatCompareColor(data.f3, data.f60)} ${buyPrice && buyPrice.length > 7 ? "trans-scale" : ""}`}>{buyPrice ?? "-"}</span>,
      hk_element: <span className={`${buyPrice && buyPrice.length > 8 ? "trans-scale" : ""} ${formatHKTimeTradeColor(data.f3, data.f60)}`}>{buyPrice ?? "-"}</span>,
    }
  },
  [quote_item_trade_info.买9量]: function (data: any) {
    return {
      element: <span>{data.f4 ?? "-"}</span>,
      hk_element: <span>{formatHKBigNumber(data.f4) ?? "-"}</span>,
    }
  },
}

export let quote_fs_trade_info = {
  [quote_item_fs_trade_info.时间]: function (item: any, isStockmore = false) {
    return {
      element: <span>{FormatArr(item, 0, isStockmore)}</span>,
    }
  },
  [quote_item_fs_trade_info.成交价]: function (tradeData: any, lastItem: string, item: any, index: number, data: any, pageNumber = 14, isStockmore = false) {
    return {
      element: (
        <>
          &nbsp;&nbsp;
          <span className={`${formatCompareColor(FormatArr(item, 1), formatNumToFixed(data.f60, data.f59))} ${FormatArr(item, 1).length > 6 ? "trans-scale" : ""}`}>
            &nbsp;{FormatArr(item, 1)}
            {isStockmore ? <>&nbsp;</> : ""}
            <span className="wrap-icon">{index == tradeData.length - 1 ? formatDirection(FormatArr(item, 1), FormatArr(lastItem, 1)) : formatDirection(FormatArr(item, 1), FormatArr(tradeData[index + 1], 1))}</span>
          </span>
        </>
      ),
      pkElement: (
        <>
          {/* &nbsp;&nbsp; */}
          <span className={`${formatCompareColor(FormatArr(item, 1), formatNumToFixed(data.f60, data.f59))} ${FormatArr(item, 1).length > 6 ? "trans-scale" : ""}`}>
            &nbsp;{FormatArr(item, 1)}
            {isStockmore ? <>&nbsp;</> : ""}
            <span className="wrap-pk-icon">{index == tradeData.length - 1 ? formatDirection(FormatArr(item, 1), FormatArr(lastItem, 1)) : formatDirection(FormatArr(item, 1), FormatArr(tradeData[index + 1], 1))}</span>
          </span>
        </>
      ),
      newElement: (
        <>
          &nbsp;&nbsp;
          <span className={`${formatCompareColor(FormatArr(item, 1), formatNumToFixed(data.f60, data.f59))} ${FormatArr(item, 1).length > 6 ? "trans-scale" : ""}`}>
            &nbsp;{FormatArr(item, 1)}
            {isStockmore ? <>&nbsp;</> : ""}
            <span className="wrap-pk-icon">{index == tradeData.length - 1 ? formatNewDirection(FormatArr(item, 1), FormatArr(lastItem, 1)) : formatNewDirection(FormatArr(item, 1), FormatArr(tradeData[index + 1], 1))}</span>
          </span>
        </>
      ),
    }
  },
  [quote_item_fs_trade_info.成交量]: function (item: any) {
    return {
      element: <span className={`${FormatArr(item, 4) == "2" ? "red" : "green"} ${formatUnit(FormatArr(item, 2), "calc", 1, 1).length > 5 ? "big-trans-scale" : ""}`}>{formatUnit(FormatArr(item, 2), "calc", 1, 1)}</span>,
      uk_element: <span className={`${FormatArr(item, 4) == "2" ? "red" : "green"} ${formatUnit(FormatArr(item, 2), "calc", 1, 1).length > 5 || getScaleClass() ? "big-trans-scale" : ""}`}>{formatUnit(FormatArr(item, 2), "calc", 1, 1)}</span>,
    }
  },
  [quote_item_fs_trade_info.国债YTM]: function (item: any, data: any) {
    return {
      element: (
        <span className={`${formatCompareColor(formatNumToFixed(data?.f60, data?.f59), FormatArr(item, 1))} ${FormatArr(item, 2).length > 6 ? "trans-scale" : ""} ${formatUnit(FormatArr(item, 2), "calc", 1, 1).length > 5 ? "big-trans-scale" : ""}`}>{formatNumToFixed(FormatArr(item, 2), 4)}</span>
      ),
      short_term_bond_element: (
        <span className={`${formatCompareColor(FormatArr(item, 1), formatNumToFixed(data?.f60, data?.f59))} ${FormatArr(item, 2).length > 6 ? "trans-scale" : ""} ${formatUnit(FormatArr(item, 2), "calc", 1, 1).length > 5 ? "big-trans-scale" : ""}`}>{formatNumToFixed(FormatArr(item, 2), 4)}</span>
      ),
    }
  },
  [quote_item_fs_trade_info.成交量_指数]: function (item: any) {
    return {
      element: <span className={`${FormatArr(item, 4) == "2" ? "red" : "green"}`}>{FormatArr(item, 2)}</span>,
    }
  },
  [quote_item_fs_trade_info.单数]: function (item: any) {
    return {
      element: <span>{FormatArr(item, 3)}</span>,
    }
  },
}

export let quote_bk_info = {
  [quote_item_bk_info.模块名称]: function (data: any) {
    return <span onClick={() => (location.href = `./stock/90.${data.f12}.html`)}>{data.f14}</span>
  },
  [quote_item_bk_info.板块涨幅]: function (data: any) {
    return (
      <span className={formatCompareColor(data.f3, 0)} onClick={() => (location.href = `./stock/90.${data.f12}.html`)}>
        {formatUnit(formatNumToFixed(data.f3, data.f152), "%", 2)}
      </span>
    )
  },
  [quote_item_bk_info.领涨股]: function (data: any) {
    if (data.f140 == "-" || data.f141 == "-") {
      return <span onClick={() => (location.href = `./stock/90.${data.f12}.html`)}>&nbsp;</span>
    }
    return <span onClick={() => (location.href = `./stock/${data.f141}.${data.f140}.html`)}>{data.f128}</span>
  },
  [quote_item_bk_info.个股涨幅]: function (data: any) {
    if (data.f140 == "-" || data.f141 == "-") {
      return <span onClick={() => (location.href = `./stock/90.${data.f12}.html`)}>&nbsp;</span>
    }
    return (
      <span className={formatCompareColor(data.f136, 0)} onClick={() => (location.href = `./stock/${data.f141}.${data.f140}.html`)}>
        {formatNumToFixed(data.f136, 2, "", "%")}
      </span>
    )
  },
}

export let quote_type_info = {
  [quote_item_type_info.名称]: function (data: any) {
    return <span>{data.f14}</span>
  },
  [quote_item_type_info.股票代码]: function (data: any) {
    return <span>{data.f12}</span>
  },
  [quote_item_type_info.最新价]: function (data: any) {
    if (getFixed(data.f2, data.f1) == "-") {
      return <span>-</span>
    }
    return <span className={data.f4 > 0 ? "red" : "green"}>{getFixed(data.f2, data.f1)}</span>
  },
  [quote_item_type_info.涨跌幅]: function (data: any) {
    if (getFixed(data.f3, data.f152) == "-") {
      return <span>-</span>
    }
    return <span className={data.f4 > 0 ? "red" : "green"}>{getFixed(data.f3, data.f152) + "%"}</span>
  },
  [quote_item_type_info.涨跌额]: function (data: any) {
    if (getFixed(data.f4, data.f1) == "-") {
      return <span>-</span>
    }
    return <span className={data.f4 > 0 ? "red" : "green"}>{getFixed(data.f4, data.f1)}</span>
  },
}

export let quote_cfg_info = {
  [quote_item_cfg_info.名称]: function (data: any) {
    return <p>{data.f14}</p>
  },
  [quote_item_cfg_info.股票代码]: function (data: any) {
    return <p>{data.f12}</p>
  },
  [quote_item_cfg_info.最新价]: function (data: any) {
    return <div className={formatCompareColor(data.f3, 0)}>{formatNumToFixed(data.f2, data.f1)}</div>
  },
  [quote_item_cfg_info.涨跌幅]: function (data: any) {
    return <div className={formatCompareColor(data.f3, 0)}>{formatNumToFixed(data.f3, data.f152, "", "%")}</div>
  },
  [quote_item_cfg_info.涨跌幅_板块]: function (data: any) {
    return <div className={formatCompareColor(data.f3, 0)}>{formatNumToFixed(data.f3, data.f1, "", "%")}</div>
  },
}

export function StockNameZoom(name: string) {
  if (name && name.length > 10 && name.length < 16 && window.innerWidth < 360) {
    return "scale-first-level"
  } else {
    return ""
  }
}

function quoteColor(num: any) {
  num = Number(num)
  if (!isNumber(num)) {
    return ""
  }
  if (num > 0) {
    return "red"
  } else if (num < 0) {
    return "green"
  }
  return "black"
}

export function zoomData(value: any, zoom: number, is_percent = false) {
  if (!isNumber(value)) {
    return "-"
  }
  if (is_percent) return (value / Math.pow(10, zoom)).toFixed(zoom) + "%"
  return (value / Math.pow(10, zoom)).toFixed(zoom)
}

function getFixed(value: any, digit: number) {
  if (value == null || value == "-" || value == undefined) {
    return "-"
  }
  return value.toFixed(digit)
}
